<template>
  <div class="uk-grid" uk-grid>
    <div class="uk-width-1-2 uk-flex uk-flex-middle">
      <div class="logo-container">
        <img alt="RueBaRue logo" src="/images/ruebarue-logo.svg" class="logo" />
      </div>
    </div>

    <div class="uk-width-1-2 uk-flex uk-flex-right uk-flex-top uk-margin-small-top">
      <div>
        <span class="company-name uk-margin-right" v-if="brandingSettings && brandingSettings.length">
          {{ brandingSettings[0]?.company_name }}
        </span>
        <a href="#" @click.prevent="logout" class="logout uk-margin-left uk-margin-right">Logout</a>
      </div>
    </div>
  </div>
  <div class="uk-flex uk-flex-center uk-flex-middle">
    <div class="uk-container">
      <h3>Guest Information</h3>
      <div class="uk-card uk-card-default uk-card-body">
        <div class="uk-grid-small uk-child-width-1-1" uk-grid>
          
          <div class="uk-margin-bottom">
            <h4>What is the last name on the reservation?</h4>
            <input
              v-model="searchLastName"
              class="uk-input"
              type="text"
            />
          </div>

          <div class="uk-margin-bottom">
            <h4>What is the check-in date?</h4>
            <input
              v-model="searchCheckInDate"
              class="uk-input"
              type="date"
            />
          </div>

          <div class="uk-flex">
            <button class="uk-button uk-button-primary" :disabled="loading" @click="fetchBookings">
              <span v-if="loading" uk-spinner="ratio: 0.5"></span>
              <span v-else>Search</span>
            </button>
            <button class="uk-button uk-button-default uk-margin-left" @click.prevent="resetSearch">
              Reset
            </button>
          </div>
        </div>

        <div v-if="guestList.length > 1" class="uk-margin-small">
          <h4>{{ guestList.length }} reservations found. Which property is the reservation for?</h4>
          <ul class="uk-list matching-reservations">
            <li
              v-for="(g, index) in guestList"
              :key="g.guest_reservation_id"
              :class="['uk-button', 'uk-button-text', { selected: selectedGuestIndex === index }]"
              @click="selectGuest(index)"
            >
              {{ g.pms_id }}
            </li>
          </ul>
        </div>

        <div v-if="serverError" class="uk-alert-danger" uk-alert>
          <p>Server error. Please contact RueBaRue Support.</p>
        </div>

        <div v-else-if="guestList.length === 0 && searched" class="uk-margin-small">
          <h4>No reservations found for that last name and check-in date.</h4>
        </div>

        <div v-if="selectedGuest" class="uk-margin-top">
          <table class="uk-table uk-table-small uk-table-divider uk-table-striped">
            <tbody>
              <tr>
                <td style="width: 40%;">
                  <strong>Guest Name<br/>
                  Phone<br/>
                  Property Id<br/>
                  Addresss<br/>
                  Door Code</strong>
                </td>
                <td style="width: 60%;">
                  {{ selectedGuest.first_name }} {{ selectedGuest.last_name }}<br/>
                  {{ selectedGuest.formatted_phone }}<br/>
                  {{ selectedGuest.pms_id }}<br/>
                  {{ selectedGuest.rental_address }}<br/>
                  {{ selectedGuest.manual_door_code || selectedGuest.door_code }}
                </td>
              </tr>
              <!--
              <tr>
                <td><strong>Check-In & Check-Out Date</strong></td>
                <td>{{ formattedDate(selectedGuest.check_in) }} - {{ formattedDate(selectedGuest.check_out) }}</td>
              </tr>
              <tr>
                <td><strong>Property ID & Address</strong></td>
                <td>
                  {{ selectedGuest.pms_id }}<br/>
                  {{ selectedGuest.rental_address }}
                </td>
              </tr>
              --> 
            </tbody>
          </table>
          <table class="uk-table uk-table-small uk-table-divider uk-table-striped">
            <tbody>
              <template v-if="orderedPropertyMacros.length">
                <tr v-for="macro in orderedPropertyMacros" :key="macro.macro_id">
                  <td style="width: 40%;"><strong>{{ formatMacro(macro.macro) }}</strong></td>
                  <td style="width: 60%;"><span v-html="macro.content"></span></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import store from "../store.js";

export default {
  data() {
    return {
      accountId: "",
      scenarios: [],
      contactInfo: "",
      brandingSettings: "",
      searchLastName: "",
      searchCheckInDate: this.getTodayDate(),
      guestList: [],
      searchTopic: "",
      selectedGuestIndex: null,
      guest: [],
      propertyMacros: [],
      store: store,
      searched: false,
      serverError: false,
      loading: false,
    };
  },
  computed: {
    selectedGuest() {
      return this.selectedGuestIndex !== null ? this.guestList[this.selectedGuestIndex] : null;
    },
    orderedPropertyMacros() {
      const macroOrder = this.propertyMacros.map(m => m.macro_id);
      const idToMacro = {};

      this.propertyMacros.forEach(macro => {
        idToMacro[macro.macro_id] = macro;
      });

      return macroOrder
        .filter(id => idToMacro[id])
        .map(id => idToMacro[id]);    
    }
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },
    debounceSearch: debounce(function () {
      this.fetchBookings();
    }, 300),
    clearTopicSearch() {
      this.searchTopic = "";
    },
    getCookie: (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    isTokenExpired(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const exp = payload.exp;
        if (!exp) return false;

        const now = Math.floor(Date.now() / 1000);
        return now >= exp;
      } catch (e) {
        console.warn("Invalid token structure", e);
        return true;
      }
    },
    async fetchBookings() {
      const token = this.getCookie("support_token");
      if (!token || this.isTokenExpired(token)) {
        this.logout();
        return;
      }    
      if (!this.store.account?.account_id || !this.searchLastName || !this.searchCheckInDate) 
        return;

      this.loading = true;
      this.searched = false;
      this.serverError = false;

      try {
        let data = JSON.stringify({
          search_term: this.searchLastName,
          filters: "all",
          preset: "soon",
          start_date: this.searchCheckInDate,
          end_date: this.searchCheckInDate,
          end_type: "check_in",
          page: 0,
          checked_in: false,
          checked_out: false,
          categories: "",
          per_page: "20",
        });

        let resConfig = {
          method: "post",
          url: `${this.store.api_root}/api/v2/support/reservation`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getCookie("support_token")}`,
          },
          data: data,
        };

        let { reservations } = await axios.request(resConfig).then(res => res.data);

        if (reservations && reservations.length > 0) {
          this.guestList = reservations;
          this.selectGuest(0);
        } else {
          this.guestList = [];
          this.selectedGuestIndex = null;
        }

        if (this.searchLastName && this.searchCheckInDate) {
          const accountId = this.store.account?.account_id;
          axios.post(`${this.store.api_root}/api/v2/support/log-search`, {
            account_id: accountId,
            last_name: this.searchLastName,
            check_in: this.searchCheckInDate,
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.getCookie("support_token")}`,
            }
          });
        }

      } catch (error) {
        console.error(error);
        this.serverError = true;
      } finally {
        this.loading = false;
        this.searched = true;
      }
    },
    async selectGuest(index) {
      this.selectedGuestIndex = index;

      const guest = this.guestList[index];
      const rentalId = guest.rental_id;
      const accountId = this.store.account?.account_id;

      if (!rentalId || !accountId) return;

      try {
        const resConfig = {
          method: "post",
          url: `${this.store.api_root}/api/v2/support/macros_values`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getCookie("support_token")}`,
          },
          data: JSON.stringify({
            rental_id: rentalId,
            account_id: accountId,
          }),
        };

        const response = await axios.request(resConfig);
        this.propertyMacros = response.data || [];
      } catch (error) {
        console.error("Error fetching property macros:", error);
        this.propertyMacros = [];
      }
    },
    async fetchBrandingSettings() {
      try {
        if (!this.store.account?.account_id) return;

        let resConfig = {
          method: "post",
          url: `${this.store.api_root}/api/v2/support/branding_settings`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getCookie("support_token")}`,
          },
          params: {
            account_id: this.store.account?.account_id,
          },
        };

        const response = await axios.request(resConfig);
        this.brandingSettings = response.data;

      } catch (error) {
        console.error("Error fetching support hub contact:", error);
      }
    },    
    resetSearch() {
      this.searchLastName = '';
      this.searchCheckInDate = this.getTodayDate();
      this.guestList = [];
      this.selectedGuestIndex = null;
      this.propertyMacros = [];
    },    
    formatMacro(macro) {
      if (!macro) return '';
      return macro
        .replace(/^\[|\]$/g, '')           // Remove square brackets
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    },
    formattedDate(date) {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    logout() {
      localStorage.removeItem("account");
      this.store.account = null;
      document.cookie = "support_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      this.$router.push("/login");
    }
  },
  mounted() {
    const token = this.getCookie("support_token");

    if (!token || this.isTokenExpired(token)) {
      this.logout();
      return;
    }

    const storedAccount = localStorage.getItem("account");
    if (storedAccount && !this.store.account?.account_id) {
      this.store.account = JSON.parse(storedAccount);
    }

    this.fetchBrandingSettings();
  }
};
</script>
